import React, { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { ptBR } from "date-fns/locale";
import { format } from "date-fns";

export default function DatePickerDialog({
  open, onOpenChange, title, description, confirmLabel, onConfirm,
  disabled = false,
}) {
  const [date, setDate] = useState(new Date());
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-sm max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading tracking-tight">{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        <div className="flex justify-center py-2">
          <Calendar
            mode="single" selected={date}
            onSelect={(d) => d && setDate(d)}
            locale={ptBR}
            className="rounded-sm border border-zinc-200"
          />
        </div>
        <div className="text-sm text-zinc-600 text-center">
          Data escolhida: <b>{format(date, "PPP", { locale: ptBR })}</b>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="rounded-sm"
          >
            Cancelar
          </Button>
          <Button
            data-testid="date-picker-confirm"
            onClick={() => onConfirm(format(date, "yyyy-MM-dd"))}
            disabled={disabled}
            className="rounded-sm bg-[#152D4B] hover:bg-[#0E1F36] text-white"
          >
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
